import React, { useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
  getPressSetupLayoutStatus,
  PRESS_SETUP_LAYOUT_STATUS,
  PRESS_SETUP_STATUS_LABELS
} from '../utils/pressSetup';

const BUTTON_STYLES = {
  [PRESS_SETUP_LAYOUT_STATUS.UNSET]: {
    backgroundColor: '#363636',
    color: 'rgba(255, 255, 255, 0.7)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    hoverBackgroundColor: '#404040',
    hoverBorderColor: 'rgba(255, 255, 255, 0.2)'
  },
  [PRESS_SETUP_LAYOUT_STATUS.DEFAULT]: {
    backgroundColor: 'rgba(var(--al-primary-rgb), 0.15)',
    color: 'var(--al-primary)',
    border: '1px solid rgba(var(--al-primary-rgb), 0.4)',
    hoverBackgroundColor: 'rgba(var(--al-primary-rgb), 0.25)',
    hoverBorderColor: 'var(--al-primary)'
  },
  [PRESS_SETUP_LAYOUT_STATUS.CUSTOM]: {
    backgroundColor: 'rgba(255, 193, 7, 0.15)',
    color: '#FFC107',
    border: '1px solid rgba(255, 193, 7, 0.5)',
    hoverBackgroundColor: 'rgba(255, 193, 7, 0.25)',
    hoverBorderColor: '#FFC107'
  }
};

const PressSetupIndicatorButton = ({ lineData, inkCatalog = [], onClick, size = 'default' }) => {
  const status = useMemo(
    () => getPressSetupLayoutStatus(lineData?.pressSetup, lineData, inkCatalog),
    [lineData, inkCatalog]
  );
  const styles = BUTTON_STYLES[status] || BUTTON_STYLES[PRESS_SETUP_LAYOUT_STATUS.UNSET];
  const dimension = size === 'compact' ? 30 : 36;
  const fontSize = size === 'compact' ? '0.95rem' : '1.1rem';

  return (
    <Tooltip title={PRESS_SETUP_STATUS_LABELS[status]}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(lineData);
        }}
        aria-label="Press setup"
        sx={{
          width: dimension,
          height: dimension,
          backgroundColor: styles.backgroundColor,
          color: styles.color,
          border: styles.border,
          borderRadius: 0,
          fontSize,
          p: 0,
          '&:hover': {
            backgroundColor: styles.hoverBackgroundColor,
            borderColor: styles.hoverBorderColor
          }
        }}
      >
        ✵
      </IconButton>
    </Tooltip>
  );
};

export default PressSetupIndicatorButton;
